import React, {useState} from 'react';
import {useUAlert} from "../index";
import {COLOR, FILE} from "../constant";
import * as Icon from 'ubs-icons';
import {checkAttachment, isThisAFile} from "../common/function";
import PropTypes from "prop-types";

const UFileAttachment = React.memo((props) => {
    const alert = useUAlert();
    const [removeFiles, setRemoveFiles] = useState([]);

    const onChange = e => {
        prepareFiles(e.target.files).then()
    }
    const remove = (index) => {
        if (props.isNestedFiles && (props.index !== undefined || props.index !== null)) {
            props.setFiles(prevState => {
                const newState = [...prevState];
                const files = [...(newState[props.index]?.files || [])];
                const removeItem = files.splice(index, 1)?.[0] || {};

                if (removeItem?._id) {
                    const removed = [...removeFiles, removeItem._id];
                    setRemoveFiles(removed);
                    props.setRemoveFiles(removed);
                }

                newState[props.index] = {...newState[props.index], files};
                return newState;
            });
        } else {
            const list = [...props.files]
            const removeItem = list.splice(index, 1)?.[0] || {}
            if (removeItem?._id) {
                const removed = [...removeFiles, removeItem._id]
                setRemoveFiles(removed)
                props.setRemoveFiles(removed)
            }
            props.setFiles(list)
        }
    }

    const prepareFiles = async (data) => {
        if ((data.length + props.files.length) <= props.maxFiles) {
            let sizeError = false;
            const fileArray = Object.assign([], data);
            for (let i = 0; i < fileArray.length; i++) {
                if (!sizeError) sizeError = fileArray[i].size / 1024 / 1024 > props.sizeLimit;
            }

            if (!sizeError) {
                const number = data.length;
                const myFiles = []
                for (let i = 0; i < number; i++) {
                    const name = fileArray[i]?.name?.split('.');
                    const ext = name[name.length - 1];
                    if (props?.fileType === 'mix-file' ? (FILE.MIXFILES.exec(fileArray[i]?.name) || (props?.allowXLS ? FILE.ELSXFILES.exec(fileArray[i]?.name) : '')) : (FILE.IMAGES.exec(fileArray[i]?.name) || FILE.VIDEO.exec(fileArray[i]?.name))) {
                        if (!FILE.EXCLUDES.includes(ext)) {
                            await isThisAFile(fileArray[i]).then(validFile => {
                                myFiles.push({obj: validFile, url: URL.createObjectURL(validFile)})
                            }).catch(error => {
                                console.log('Error in check files', error.message)
                            });
                        }
                    } else {
                        alert.show({title: 'Something went wrong.', description: `Unsupported File.`})
                    }
                }
                if (props.isNestedFiles && (props.index !== undefined || props.index !== null)) {
                    props.setFiles(prevState => {
                        const newState = [...prevState];
                        newState[props.index] = {...newState[props.index], files: [...(newState[props.index]?.files || []), ...myFiles]};
                        return newState;
                    })
                } else {
                    props.setFiles([...props.files, ...myFiles])
                }
            } else {
                alert.show({
                    title: 'Something went wrong.',
                    description: `Files must smaller than ${props.sizeLimit}MB!`
                })
            }
        } else {
            alert.show({
                title: 'Something went wrong.',
                description: ` You can upload only ${props.maxFiles} files at a time.`
            })
        }
    };
    const viewFiles = (i) => {
        props?.dispatch({type: 'SET_FILES', payload: {files: props.files?.filter(item => !item.obj), active: i || 0}});
    }

    return (
        <React.Fragment>
            <div className='u_profile-documents'>
                {props.files.map((data, index) => {
                    return <div className="u_profile-document-preview u_ib u_flex-shrink u_mr-10" key={index}>
                        {
                            ['pdf', 'xls', 'xlsx']?.includes(checkAttachment(data?.obj?.name || data?.url)) ?
                                <div className="u_profile-document-pdf" style={{height: `${props.size}px`, width: `${props.size}px`}}>
                                    {checkAttachment(data?.obj?.name || data?.url) === 'pdf' ? <Icon.PDF size={14} fill={COLOR.u_red}/> : <Icon.XLS size={14} fill={COLOR.u_blue}/>}
                                    <p className="u_one-line u_font">{data?.obj?.name}</p>
                                </div> :
                                FILE.IMAGES.exec(data?.obj?.name) || FILE.IMAGES.exec(data?.url) ?
                                    <img src={(data?.obj ? '' : (props?.getThumbor() + props?.S3URL)) + data?.url} alt=""
                                         style={{height: `${props.size}px`, width: `${props.size}px`}}
                                         className="u_img-inner"/> :
                                    <div className={`u_file-popup u_file-popup-video`}>
                                        <video className="" src={(data?.obj ? '' : (props?.getThumbor() + props?.S3URL)) + data?.url}
                                               style={{height: `${props.size}px`, width: `${props.size}px`}}/>
                                    </div>
                        }

                        <ul className="u_profile-document-preview-options u_flex u_align-center">
                            {props.options.includes('delete') && !props?.isDisabled && <li className="u_mr-5">
                                <span className="u_img-option u_cp" onClick={() => remove(index)}><Icon.Delete size={16}
                                                                                                               fill={COLOR.u_white}/></span>
                            </li>}
                            {props.options.includes('download') && !data?.obj && <li className="u_mr-5">
                                <a href={`${props?.S3URL}${data?.url}`} target="_blank" download
                                   className="u_block u_cp u_img-option-left"><Icon.Download size={16}
                                                                                             fill={COLOR.u_white}/></a>
                            </li>}
                            {props.options.includes('view') && !data?.obj && <li>
                                {['pdf', 'xls', 'xlsx']?.includes(checkAttachment(data?.obj?.name || data?.url)) ?
                                    <a href={`${props?.S3URL}${data?.url}`} target="_blank" download
                                    className="u_block u_cp u_img-option-left"><Icon.Eye size={16} fill={COLOR.u_white}/></a> :
                                    <span className="u_img-option u_cp" onClick={() => viewFiles(index)}><Icon.Eye size={16} fill={COLOR.u_white}/></span>}
                            </li>}
                        </ul>
                    </div>
                })}
                <React.Fragment>
                    {props.showInput && props.files.length < props.maxFiles &&
                    <div className={`u_attach-more ${props.errorClass}`}
                         style={{height: `${props.size}px`, width: `${props.size}px`}}>
                        <input type='file' className="u_attach-more-input u_cp" title=""
                               onClick={(e) => e.target.value = ""}
                               id={`u_upload`} accept={props.accept}
                               autoComplete="off" multiple={props.maxFiles > 1} onChange={onChange}
                               disabled={props?.isDisabled}/>
                        <div className="u_file-attachment-btn u_m-auto u_cp">
                            <Icon.Attachment size={18}/>
                        </div>
                    </div>}
                </React.Fragment>
            </div>
        </React.Fragment>
    );
});

export default UFileAttachment;

UFileAttachment.defaultProps = {
    files: [], // [{url:'',obj:null}]
    setFiles: () => {
    },
    showInput: true,
    maxFiles: 1,
    sizeLimit: 3, // in mb,
    accept: "image/*", // default only images,
    options: ['delete', 'view', 'download'],
    size: 60,
    errorClass: '',
    removeFiles: [],
    setRemoveFiles: () => {
    },
}

UFileAttachment.propTypes = {
    files: PropTypes.array,
    setFiles: PropTypes.func,
    maxFiles: PropTypes.number,
    sizeLimit: PropTypes.number,
    accept: PropTypes.string,
    options: PropTypes.array,
    size: PropTypes.number,
}